import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Add, GroupAddOutlined } from '@material-ui/icons';

import { showMessage } from '../../../actions/globalActions';
import { messageTypes } from '../../../constants/mediaConstants';

import AddSpeakerModal from './AddSpeakerModal';

import './LiveManagerParticipants.scss';
import './Modal.scss';

interface TemporaryAddParticipantSectionProps {
    mediaId?: string;
    mediaDetails?: any;
    linkedFormId?: string;
}

const TemporaryAddParticipantSection: React.FC<TemporaryAddParticipantSectionProps> = ({ mediaId = '', mediaDetails, linkedFormId = '' }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch() as any;
    const jitsiApi = useSelector((state: any) => state.liveManager.jitsiApi);
    const jitsiRoomName = useSelector((state: any) => state.liveManager.jitsiRoomName);
    const accountId = useSelector((state: any) => state.session.defaultAccountId);

    const [showAddSpeakerModal, setShowAddSpeakerModal] = useState(false);

    const handleInviteUser = () => {
        if (jitsiApi && jitsiRoomName) {
            const eventDomain = process.env.REACT_APP_EVENT_REGISTRATION_URL || window.location.hostname;
            const meetingUrl = `${eventDomain}/${accountId}/${linkedFormId}/${jitsiRoomName}`;

            navigator.clipboard.writeText(meetingUrl).then(() => {
                dispatch(showMessage(t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_PARTICIPANTS_MEETING_LINK_COPIED'), messageTypes.info));
            }).catch((error) => {
                dispatch(showMessage(t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_PARTICIPANTS_MEETING_LINK_COPY_THIS_LINK') + `: ${error}`, meetingUrl));
            });
        } else {
            console.warn('Missing requirements:', { jitsiApi: !!jitsiApi, jitsiRoomName });
            dispatch(showMessage(t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_PARTICIPANTS_MEETING_LINK_MISSING'), messageTypes.warning));
        }
    };

    if (!linkedFormId) {
        return (
            <div className="container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '12px' }}>
                Please set up the meeting form first to add participants.
            </div>
        );
    }

    return (
        <div className="container">
            <div className="header">
                <div className="row">
                    <GroupAddOutlined />
                </div>
                <div className='header-action'>
                    <Button
                        className='btn'
                        variant={'contained'}
                        color="primary"
                        onClick={handleInviteUser}
                        startIcon={<Add />}
                    >
                        {t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_PARTICIPANTS_ADD')}
                    </Button>
                    <Button
                        className='btn'
                        variant={'contained'}
                        color="primary"
                        onClick={() => setShowAddSpeakerModal(true)}
                        startIcon={<Add />}
                    >
                        {t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_PARTICIPANTS_ADD_SPEAKER')}
                    </Button>
                </div>
            </div>

            <AddSpeakerModal
                open={showAddSpeakerModal}
                onClose={() => setShowAddSpeakerModal(false)}
                mediaId={mediaId}
                mediaDetails={mediaDetails}
            />
        </div>
    );
};

export default TemporaryAddParticipantSection;